var React = require('react');

function TextInput (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"y":"92","width":"288","height":"48","rx":"2","fill":"white","key":1}),React.createElement("rect",{"x":"0.5","y":"92.5","width":"287","height":"47","stroke":"#737373","key":2}),React.createElement("rect",{"x":"16","y":"104","width":"256","height":"24","fill":"#D8D8D8","key":3}),React.createElement("rect",{"x":"16","y":"60","width":"100","height":"24","fill":"#D8D8D8","key":4})]);
}

TextInput.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = TextInput;

TextInput.default = TextInput;
